import { gql } from '@apollo/client'

export const SELF_ASSIGN_PROCESSING = gql`
  mutation selfAssignProcessing($poolSlug: String!, $id: ID, $ids: [ID!]) {
    selfAssignProcessing(poolSlug: $poolSlug, id: $id, ids: $ids) {
      id
      m2Case {
        id
      }
    }
  }
`
